import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'v1_commitment'

const OPTIONS = [
  {
    value: 'Fully committed',
    translationKey: 'pages.onboarding.commitment.options.fully',
    subtextKey: 'pages.onboarding.commitment.subtexts.fully',
  },
  {
    value: 'Mostly ready',
    translationKey: 'pages.onboarding.commitment.options.mostly',
    subtextKey: 'pages.onboarding.commitment.subtexts.mostly',
  },
  {
    value: 'Need a push',
    translationKey: 'pages.onboarding.commitment.options.needPush',
    subtextKey: 'pages.onboarding.commitment.subtexts.needPush',
  },
  {
    value: 'Just exploring',
    translationKey: 'pages.onboarding.commitment.options.exploring',
    subtextKey: 'pages.onboarding.commitment.subtexts.exploring',
  },
]

export default function CommitmentPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How ready are you to start your decluttering journey?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.commitment.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
